class SettingSource {
    constructor(API) {
        this.API = API;
    }

    async list(data) {
        return await this.API.get('/settings.json', {
            params: data
        })
    }

}

export default SettingSource
